import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Select from 'react-select';
import LeftNav from '../../../../components/common/employee/leftnav.component';
import TopNav from '../../../../components/common/employee/topnav.component';
import { ValidateEmployeeRole } from "../../../../components/helper/validateRole";
import EmpLogin from "../../../../setup/auth/emp.component";
import { reactLocalStorage } from 'reactjs-localstorage';
import { Country, Employee, FinancialYear, Parameters, Plan, Relationship, RelationshipDetails, Roles, SBU, TargetDetails, Targets } from "../../../../models";
import moment from "moment";
import { DataStore, Predicates, SortDirection } from '@aws-amplify/datastore';
import { ConvertResponseForSelect } from '../../../../components/helper/commonfunctions';
import { ObjectToArray, ConvertEnumToArrayKeyValue } from '../../../../components/helper/commonfunctions';
import { PARAMETERS_TYPES, PARAMETERS_TYPES_NAMES, PARAMETER_IDs, QUARTERS_NAME } from '../../../../components/helper/enum';
import ViewButton from '../../../../components/common/buttons/ViewButton';
import popupHeaderImg from "../../../../assets/images/popup_header_img.png";
import { Storage } from 'aws-amplify';
import { Avatar } from "@mui/material";
import { toast } from 'react-toastify';
import EvaluationEmployeePopUp from '../employeeEvaluation';
import { sumFromArray } from '../../../../components/helper/maths';
import { commaSeparated } from '../../../../components/helper/maths';
//import { queries } from '@testing-library/react';
import * as queries from '../../../../graphql/queries';
import * as mutations from '../../../../graphql/mutations';
import { graphQLGetAllData, graphQLFindRecordById } from '../../../../../src/components/helper/graphQLFunctions'


export default function CurrentYearTeam_Report() {

    let isReportingManager = reactLocalStorage.get('isReportingManager')
    var loggedEmployeeId = reactLocalStorage.get('loggedEmployeeId');
    let selectedYear = reactLocalStorage.getObject('selectedYear');
    let selectedTabEvaluation = reactLocalStorage.get('selectedTabEvaluation')

    const navigateTo = useNavigate()

    const [myTeam, setMyTeam] = useState([]);
    const [renderItems, setRenderItems] = useState(false);

    //Financial Year
    const [financialYear, setFinancialYear] = useState("");
    const [financialYearList, setFinancialYearList] = useState([]);

    //Validate User Logged In
    const [isAuthenticated, userHasAuthenticated] = useState(true);

    // states
    const [quarter, setQuarter] = useState("");
    const [quarterList, setQuarterList] = useState("");
    const [viewEmpEvaluation, setViewEmpEvaluation] = useState(false);


    // set Employee 
    const [selectedEmployeeId, setSelectedEmployeeId] = useState("");
    const [selectedEmployeeName, setSelectedEmployeeName] = useState("");
    const [selectedEmployeeProfilePic, setSelectedEmployeeProfilePic] = useState("");
    const [selectedEmployeeCode, setSelectedEmployeeCode] = useState("");
    const [selectedEmployeeSBU, setSelectedEmployeeSBU] = useState("");
    const [selectedEmployeeRole, setSelectedEmployeeRole] = useState("");
    const [selectedEmployeeRegion, setSelectedEmployeeRegion] = useState("");
    const [selectedEmployeeCountry, setSelectedEmployeeCountry] = useState("");
    const [selectedEmployeeTarget, setSelectedEmployeeTarget] = useState([]);
    const [selectedEmployeeRoleId, setSelectedEmployeeRoleId] = useState([]);
    const [selectedParentEmployeeName, setSelectedParentEmployeeName] = useState([]);

    //onclick financial year
    const onFinancialSelectChange = async (e) => {
        setFinancialYear({ label: e.label, value: e.value })
    }

    async function onLoad() {
        //set financial year
        let selectedQuarter = reactLocalStorage.getObject('selectedQuarter');
        let selectedYear = reactLocalStorage.getObject('selectedYear');

        let date = moment().format("MM-DD")
        let currentYear = moment().year()
        let previousYear = moment().year() - 1
        let nextYear = moment().year() + 1
        let FinalYearResult = ""
        if ("03-31" < date) {
            FinalYearResult = currentYear + "-" + nextYear
        }
        else {
            FinalYearResult = previousYear + "-" + currentYear
        }
        // var responses = await DataStore.query(FinancialYear, (c) => c.name.contains(FinalYearResult));

        var responses = await graphQLGetAllData('listFinancialYears', [{ name: { contains: FinalYearResult } }]);


        if (selectedYear.value !== undefined) {
            setFinancialYear({ label: selectedYear.label, value: selectedYear.value })
        } else {
            setFinancialYear({ label: responses[0].name, value: responses[0].id })
        }
        // setFinancialYear({ label: responses[0].name, value: responses[0].id })


        //get financial year
        // var responses = await DataStore.query(FinancialYear, Predicates.ALL, {
        //     sort: s => s.name(SortDirection.ASCENDING)
        // });
        var responses = await graphQLGetAllData('listFinancialYears', [{ _deleted: { attributeExists: false } }]);
        responses = responses.sort((a, b) => a.name.localeCompare(b.name));
        var myArray = []; myArray = ConvertResponseForSelect(responses); setFinancialYearList(myArray);

        try {
            if (!ValidateEmployeeRole()) {
                userHasAuthenticated(false);
            }
        } catch (e) {
            userHasAuthenticated(false);
        }

        //setQuarter
        if (Object.keys(selectedQuarter).length !== 0) {
            //setQuarter(selectedQuarter)
        }

        //QuarterList
        var myQuarterArray = []; myQuarterArray = ConvertEnumToArrayKeyValue(QUARTERS_NAME);;
        setQuarterList(myQuarterArray)

    }

    //Table View button
    const actionBodyTemplate = (selectedEmployee) => {
        return (
            <React.Fragment>
                <Link onClick={() => openEmployeeEvaluation(selectedEmployee)} ><ViewButton /></Link>
            </React.Fragment>
        )
    }




    const openEmployeeEvaluation = async (selectedEmployee) => {
        setSelectedEmployeeId(selectedEmployee.id)
        setSelectedParentEmployeeName(selectedEmployee.parentEmployeeName)

        setSelectedEmployeeName(selectedEmployee.employeeName)
        setSelectedEmployeeProfilePic(selectedEmployee.profilePic)
        setSelectedEmployeeCode(selectedEmployee.employeeId)
        setSelectedEmployeeSBU(selectedEmployee.sbu)
        setSelectedEmployeeRole(selectedEmployee.roleName)
        setSelectedEmployeeRegion(selectedEmployee.region)
        setSelectedEmployeeCountry(selectedEmployee.country)
        setSelectedEmployeeRoleId(selectedEmployee.role_id)

        setViewEmpEvaluation(true)


        // var selectedEmpTarget = await DataStore.query(Targets, (c) => c.and(c => [
        //     c.employee_id.eq(selectedEmployee.id),
        //     c.financial_year_id.eq(financialYear.value),
        // ]));

        // if (selectedEmpTarget.length > 0) {
        //     //Target Details
        //     var currentTargetDetails = await DataStore.query(TargetDetails, (c) => c.and(c => [
        //         c.target_id.eq(selectedEmpTarget[0].id),
        //     ]));


        //     let newResponse = []
        //     Object.keys(currentTargetDetails).map(async (currentItem, i) => {
        //         let loopTargetItem = currentTargetDetails[currentItem];
        //         let data = ObjectToArray(loopTargetItem);

        //         // //get Q2 rec from plan 
        //         var currentPlanDetails = await DataStore.query(Plan, (c) => c.target_detail_id.eq(data["id"]));
        //         //get Parameter
        //         var parameter = await DataStore.query(Parameters, data["parameter_id"]);
        //         data["parameter"] = parameter.name
        //         data["parameterUnit"] = parameter.type === PARAMETERS_TYPES.Days ? PARAMETERS_TYPES_NAMES.D : parameter.type === PARAMETERS_TYPES.Amount ? PARAMETERS_TYPES_NAMES.A : parameter.type === PARAMETERS_TYPES.Number ? PARAMETERS_TYPES_NAMES.N : PARAMETERS_TYPES_NAMES.P
        //         data["planActual_value"] = currentPlanDetails.length

        //         newResponse.push(data)


        //         if (i === currentTargetDetails.length - 1) {
        //             setSelectedEmployeeTarget(newResponse)
        //             setViewEmpEvaluation(true)
        //         }
        //     })
        // } else {
        //     toast.error("Data not available.")
        // }
    }

    useEffect(() => {
        onLoad();
    }, []);

    async function getTargetOfRevenue(employeeId) {
        let selectedYear = reactLocalStorage.getObject('selectedYear');
        // var selectedTarget = await DataStore.query(Targets, (c) => c.and(c => [
        //     c.employee_id.eq(employeeId),
        //     c.financial_year_id.eq(selectedYear.value),
        //     c.report_manager_employee_id.eq(employeeId)
        // ]));

        var selectedTarget = await graphQLGetAllData('listTargets', [{
            employee_id: { eq: employeeId },
            financial_year_id: { eq: selectedYear.value },
            report_manager_employee_id: { eq: employeeId },
        }]);



        // var getALLTarget = await DataStore.query(TargetDetails, (c) => c.and(c => [
        //     c.target_id.eq(selectedTarget[0].id),
        //     c.parameter_id.eq(PARAMETER_IDs.Revenue)
        // ]));
     

        var getALLTarget = [];
        if (selectedTarget.length >0) {
            getALLTarget = await graphQLGetAllData('listTargetDetails', [{
                target_id: { eq: selectedTarget[0].id },
                parameter_id: { eq: PARAMETER_IDs.Revenue },
            }]);
        }

        return getALLTarget
    }

    async function getPercentage(employeeId) {
        // var selectedTarget = await DataStore.query(Targets, (c) => c.and(c => [c.employee_id.eq(employeeId), 
        //     c.financial_year_id.eq(selectedYear.value), 
        //     c.report_manager_employee_id.eq(employeeId)]));

        var selectedTarget = await graphQLGetAllData('listTargets', [{
            employee_id: { eq: employeeId },
            financial_year_id: { eq: selectedYear.value },
            report_manager_employee_id: { eq: employeeId },
        }]);

        if (selectedTarget.length) {
            //get WEIGHTAGE ---- 
            // var relationshipResponse = await DataStore.query(Relationship, (c) => c.and(c => [c.role_id.eq(selectedTarget[0].role_id),
            //  c.financial_year_id.eq(selectedYear.value)]));

            var relationshipResponse = await graphQLGetAllData('listRelationships', [{
                role_id: { eq: selectedTarget[0].role_id },
                financial_year_id: { eq: selectedYear.value },
            }]);

            var relationshipDetailResponses = []
            if (relationshipResponse.length > 0) {
                // relationshipDetailResponses = await DataStore.query(RelationshipDetails, (c) => c.relationship_id.eq(relationshipResponse[0].id)); }

                relationshipDetailResponses = await graphQLGetAllData('listRelationshipDetails', [{ relationship_id: { eq: (relationshipResponse[0].id) } }]);
                //get WEIGHTAGE ---- 

                //get Targets of Revenue , NWC DAYS, GROSS MARGIN
                //var getALLTarget = await DataStore.query(TargetDetails, (c) => c.target_id.eq(selectedTarget[0].id));
                var getALLTarget = await graphQLGetAllData('listTargetDetails', [{ target_id: { eq: (selectedTarget[0].id) } }]);

                let filterTargets = getALLTarget.filter(e => e.parameter_id === PARAMETER_IDs.Revenue || e.parameter_id === PARAMETER_IDs['NWC DAYS'] || e.parameter_id === PARAMETER_IDs['Gross Margin %'] || e.parameter_id === PARAMETER_IDs['Gross Margin $'])
                const commonEntries = relationshipDetailResponses.filter(obj1 => { return filterTargets.some(obj2 => { return obj1.parameter_id === obj2.parameter_id }); });

                var weightagePercentage = sumFromArray('weightage', commonEntries);
                return weightagePercentage + "%"
            } else {
                return 0
            }

        }
    }

    const bindData = async () => {
        if (isReportingManager === "1") {
            //var myTeamMembers = await DataStore.query(Employee, (c) => c.parentEmployeeId.eq(loggedEmployeeId));
            var myTeamMembers = await graphQLGetAllData('listEmployees', [{ parentEmployeeId: { eq: loggedEmployeeId } }]);

            let newResponse = []
            if (myTeamMembers.length > 0) {

                for (var i = 0; i < myTeamMembers.length; i++) {
                    let profilePic = "";
                    var getParentEmployee = "";
                    var targetValue = 0;
                    var getSbu = "";
                    await Storage.get(myTeamMembers[i]["profilePic"]).then(result => { profilePic = result });

                    //getParentEmployee
                    if (myTeamMembers[i]["parentEmployeeId"] !== "") {
                        // getParentEmployee = await DataStore.query(Employee, (c) => c.id.eq(myTeamMembers[i]["parentEmployeeId"]));
                        // console.log('getParentEmployee-datastore',getParentEmployee)

                        getParentEmployee = await graphQLFindRecordById('getEmployee', myTeamMembers[i]["parentEmployeeId"]);


                    }

                    //getRole
                    //var getRole = await DataStore.query(Roles, myTeamMembers[i]["role_id"]);
                    var getRole = await graphQLFindRecordById('getRoles', myTeamMembers[i]["role_id"]);
                    let getRevenue = await getTargetOfRevenue(myTeamMembers[i].id)
               

                    if (getRevenue.length >0) {
                        targetValue = "$" + commaSeparated(parseFloat(getRevenue[0].target_value).toFixed(2))
                    }

                    let getPercentageOfParameters = await getPercentage(myTeamMembers[i].id)

                    //getSBU
                    if (myTeamMembers[i]["param_sbu_id"] !== null && myTeamMembers[i]["param_sbu_id"] !== "") {
                        //getSbu = await DataStore.query(SBU, myTeamMembers[i]["param_sbu_id"]);
                        getSbu = await graphQLFindRecordById('getSBU', myTeamMembers[i]["param_sbu_id"]);
                    }

                    let data = {
                        "id": myTeamMembers[i]["id"],
                        "employeeId": myTeamMembers[i]["employeeId"],
                        'employeeName': myTeamMembers[i]["firstName"] + " " + myTeamMembers[i]["lastName"],
                        'profilePic': profilePic,
                        "parentEmployeeName": getParentEmployee.firstName + " " + getParentEmployee.lastName,
                        "roleName": getRole.name,
                        "at": targetValue,
                        "vertical": "Distribution",
                        "sbu": getSbu ? getSbu.name : '',
                        "percentage": getPercentageOfParameters
                    }

                    newResponse.push(data);

                    if (i === myTeamMembers.length - 1) {
                        let sortArray = newResponse.sort((a, b) => (a.employeeName > b.employeeName ? 1 : -1))
                        setMyTeam(sortArray)
                        setRenderItems(true)
                    }
                }

            } else {
                setMyTeam([])
                setRenderItems(true)
            }

            // Object.keys(myTeamMembers).map(async (currentItem, i) => {
            //     try {
            //         let loopEmployeeItem = myTeamMembers[currentItem];
            //         let data = ObjectToArray(loopEmployeeItem);
            //         let profilePic = ""

            //         //get country
            //         if (myTeamMembers[currentItem]["param_country_id"] !== null || myTeamMembers[currentItem]["param_country_id"] !== "") {
            //             var getCountry = await DataStore.query(Country, myTeamMembers[currentItem]["param_country_id"]);
            //             data["country"] = getCountry.name
            //         }

            //         await Storage.get(myTeamMembers[currentItem]["profilePic"]).then(result => { profilePic = result });
            //         data['profilePic'] = profilePic

            //         data['employeeName'] = myTeamMembers[currentItem]["firstName"] + " " + myTeamMembers[currentItem]["lastName"]

            //         //get Role name
            //         var getRole = await DataStore.query(Roles, myTeamMembers[currentItem]["role_id"]);
            //         data['roleName'] = getRole.name

            //         data["percentage"] = "80%"
            //         data["at"] = "-"

            //         //getParentEmployee
            //         if (myTeamMembers[currentItem]["parentEmployeeId"] !== "") {
            //             var getParentEmployee = await DataStore.query(Employee, (c) => c.id.eq(loopEmployeeItem["parentEmployeeId"]));
            //             data["parentEmployeeName"] = getParentEmployee.firstName + " " + getParentEmployee.lastName
            //         }

            //         data["vertical"] = "Distribution"

            //         //get SBU
            //         if (myTeamMembers[currentItem]["param_sbu_id"] !== null && myTeamMembers[currentItem]["param_sbu_id"] !== "") {
            //             var getSbu = await DataStore.query(SBU, myTeamMembers[currentItem]["param_sbu_id"]);
            //             data["sbu"] = getSbu.name
            //         }

            //         newResponse.push(data);

            //         if (i === myTeamMembers.length - 1) {
            //             let sortArray = newResponse.sort((a, b) => (a.employeeName > b.employeeName ? 1 : -1))
            //             setMyTeam(sortArray)
            //             setRenderItems(true)
            //         }
            //     } catch (e) {
            //     }
            // })

        }
    }

    useEffect(() => {
        bindData()
    }, []);

    return isAuthenticated ? (
        <div className="pt-16">
            <TopNav />
            <LeftNav />

            <div className="dashboard-main-wrapper target-main-wrapper pl-16" x-data="{tab: 1}">
                <div className="p-5">
                    <div className="flex justify-between">
                        <div className="sm:flex items-center space-x-4">
                            <button
                                onClick={() => { navigateTo(-1) }}
                                className="text-[#344054] text-[14px] dark:text-white py-1.5 px-3 rounded-md border border-[#D0D5DD]"><i className="icon arrow_left_double mr-6 "></i>Back</button>
                            <div className="text-2xl font-semibold dark:text-white">Goals Evaluation</div>
                        </div>
                    </div>


                    <div className="lg:flex justify-between my-6">
                        <div className="tabs_two">
                            <ul className="flex">
                                <li><Link className='active'>{selectedTabEvaluation}</Link></li>
                                {/* <li><Link  >Historical</Link></li> */}
                            </ul>
                        </div>
                        <div className="mt-5 lg:mt-0 flex items-center gap-4">
                            <div className="relative">
                                <input type="text" id="required-search" className=" rounded-lg border border-[#D0D5DD] focus:border-transparent w-250 py-2.5 pr-5 pl-9 bg-white text-gray-700 placeholder-gray-500 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 dark:bg-[#403E3C] dark:text-[#FFFFFF] dark:border-[#403E3C] dark:placeholder-[#ffff]" placeholder="Search..." />
                                <button type="submit" className="absolute left-3 top-1/2 translate-y-[-50%] dark ">
                                    <i className="icon search_icon "></i>
                                </button>
                            </div>
                            <div className="w-full min-w-[200px]">
                                <Select
                                    isDisabled={true}
                                    options={financialYearList}
                                    value={financialYear}
                                    onChange={e => {
                                        onFinancialSelectChange(e)
                                        reactLocalStorage.setObject('selectedYear', e);
                                    }}
                                    className="mt-2 mb-2  my-react-select-container"
                                    classNamePrefix="my-react-select"
                                />
                            </div>
                            <div className="w-full min-w-[200px]">
                                <Select
                                    value={quarter}
                                    options={quarterList}
                                    onChange={setQuarter}
                                    className="mt-2 mb-2  my-react-select-container"
                                    classNamePrefix="my-react-select"
                                />
                            </div>
                        </div>
                    </div>

                    <div className="rounded-lg mt-5">
                        {
                            renderItems &&
                            <DataTable paginator
                                value={myTeam}
                                responsiveLayout="scroll" style={{ width: '93vw' }}
                                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" rows={10} rowsPerPageOptions={[10, 20, 50]}
                            >
                                <Column field="employeeId" header="Employee ID" sortable filter></Column>
                                <Column field="employeeName" header="Name" sortable filter></Column>
                                <Column field="roleName" header="Role" sortable filter></Column>
                                <Column field="vertical" header="Vertical" sortable filter></Column>
                                <Column field="sbu" header="SBU" sortable filter></Column>
                                <Column header="Percentage" field="percentage" sortable filter></Column>
                                <Column header="Annual Target Revenue(M)" field='at' sortable filter ></Column>
                                <Column header="Action" body={actionBodyTemplate}></Column>
                            </DataTable>
                        }

                    </div>

                </div>
            </div>


            <div id="selector" className={viewEmpEvaluation ? 'overlay' : ''}></div>
            {/* <div id="selector" className={viewEmpEvaluation ? 'overlay' : ''}></div> */}
            {
                viewEmpEvaluation ?
                    <EvaluationEmployeePopUp
                        financialYearId={financialYear.value}
                        selectedEmployeeId={selectedEmployeeId}
                        selectedEmployeeCode={selectedEmployeeCode}
                        selectedEmployeeName={selectedEmployeeName}
                        selectedEmployeeProfilePic={selectedEmployeeProfilePic}
                        selectedEmployeeRole={selectedEmployeeRole}
                        selectedEmployeeRoleId={selectedEmployeeRoleId}
                        selectedParentEmployeeName={selectedParentEmployeeName}
                        selectedEmployeeCountry={selectedEmployeeCountry}
                        selectedEmployeeRegion={selectedEmployeeRegion}
                        selectedEmployeeSBU={selectedEmployeeSBU}

                        financialYear={financialYear.label}
                        quarter={quarter?.label}

                        closeEmpEvaluation={() => setViewEmpEvaluation(false)}
                        openEmpEvaluation={() => setViewEmpEvaluation(true)}

                    />
                    : null
            }

        </div>
    )
        : (
            <EmpLogin sessionExpired={1} />
        );
}